var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5H16C15.4 9.5 15 9.9 15 10.5C15 11.1 15.4 11.5 16 11.5H18C18.6 11.5 19 11.9 19 12.5V19.5C19 20.1 18.6 20.5 18 20.5H6C5.4 20.5 5 20.1 5 19.5V12.5C5 11.9 5.4 11.5 6 11.5H8C8.6 11.5 9 11.1 9 10.5C9 9.9 8.6 9.5 8 9.5H6C4.3 9.5 3 10.8 3 12.5V19.5C3 21.2 4.3 22.5 6 22.5H18C19.7 22.5 21 21.2 21 19.5V12.5C21 10.8 19.7 9.5 18 9.5ZM9.7 7.2L11 5.9V17.5C11 18.1 11.4 18.5 12 18.5C12.6 18.5 13 18.1 13 17.5V5.9L14.3 7.2C14.5 7.4 14.7 7.5 15 7.5C15.3 7.5 15.5 7.4 15.7 7.2C16.1 6.8 16.1 6.2 15.7 5.8L12.7 2.8C12.3 2.4 11.7 2.4 11.3 2.8L8.3 5.8C7.9 6.2 7.9 6.8 8.3 7.2C8.7 7.6 9.3 7.6 9.7 7.2Z",
    fill: "#95979C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.83edd5e715879305f7fa305588611968.svg";
export { ForwardRef as ReactComponent };